// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullScreenLoading_wrapper__1AG6v","wrapper_initialized":"FullScreenLoading_wrapper_initialized__3L3Qu"};